import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LaxmiPriyaRealEstate from './pages/LaxmiPriyaRealEstate';
import MarutiFlyAshBricks from './pages/MarutiFlyAshBricks';
import PadmabatiMandap from './pages/PadmabatiMandap';
import Marutiply from './pages/Marutiply';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

function AnimatedRoutes() {
  const location = useLocation();
  const nodeRef = React.useRef(null);
  return (
    <>
      <ScrollToTop />
      <TransitionGroup>
        <CSSTransition key={location.pathname} classNames="fade" timeout={400} nodeRef={nodeRef}>
          <div ref={nodeRef}>
            <Routes location={location}>
              <Route path="/" element={<App />} />
              <Route path="/laxmi-priya-real-estate" element={<LaxmiPriyaRealEstate />} />
              <Route path="/maruti-fly-ash-bricks" element={<MarutiFlyAshBricks />} />
              <Route path="/padmabati-mandap" element={<PadmabatiMandap />} />
              <Route path="/maruti-ply" element={<Marutiply />} />
            </Routes>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  </React.StrictMode>
);
